const AUDIT_UUID_PATTERN =
  /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/i;

export const AUDIT_MAX_FILTER_IDS = 50;

export const isAuditUuid = (value: string): boolean => AUDIT_UUID_PATTERN.test(value);

export type TAuditIdList = {
  valid: string[];
  invalid: string[];
  tooMany: boolean;
};

export const parseAuditIdList = (text: string): TAuditIdList => {
  const tokens = text.split(/[\s,]+/).filter(Boolean);
  const validByKey = new Map<string, string>();
  tokens.filter(isAuditUuid).forEach((token) => {
    if (!validByKey.has(token.toLowerCase())) {
      validByKey.set(token.toLowerCase(), token);
    }
  });
  const valid = [...validByKey.values()];
  return {
    valid,
    invalid: [...new Set(tokens.filter((token) => !isAuditUuid(token)))],
    tooMany: valid.length > AUDIT_MAX_FILTER_IDS,
  };
};

export const toAuditIdQuery = (text: string): string[] | undefined => {
  const { valid, tooMany } = parseAuditIdList(text);
  return valid.length > 0 && !tooMany ? valid : undefined;
};

export const isUnusableAuditIdFilter = (text: string): boolean =>
  text.trim() !== '' && toAuditIdQuery(text) === undefined;
